/* import __COLOCATED_TEMPLATE__ from './signature-review.hbs'; */
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SharedQuestionnaireSignatureReview extends Component {
  @service session;
}
